import { NodeExtension } from '../../../core/index.js';
import { TextSelection, PluginKey, Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import 'prosemirror-commands';
import 'prosemirror-inputrules';
import { Slice, Fragment } from 'prosemirror-model';
import ReactDOM, { render } from 'react-dom';
import React, { Component } from 'react';
import { createInstance } from '@sailor/i18n-web';
import 'classnames';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var noop = function() {};
function getInsertBlockNodes(state, node) {
    var schema = state.schema, selection = state.selection, doc = state.doc;
    var paragraph = schema.nodes.paragraph;
    var $from = selection.$from, $to = selection.$to, to = selection.to;
    var afterNode = $to.nodeAfter;
    var fromNodeGrandParent = $from.node(-1);
    var fromNodeParent = $from.node();
    // 光标在文档尾部
    if (!afterNode) {
        var nodes = [
            node,
            paragraph.create()
        ];
        // 是否在文档尾部后单元格尾部
        var isInTail = to === doc.content.size - 1 || (fromNodeGrandParent && fromNodeGrandParent.lastChild) === fromNodeParent;
        if (isInTail) return nodes;
        // 后面一行是否为文本块节点（即有内联内容的块级节点，schema中定义content为inline或者text的节点例如段落、标题, ）
        var nextNode = to < doc.content.size ? doc.nodeAt(to + 1) : null;
        if (nextNode && !nextNode.isTextblock && !nextNode.isText) {
            // 后面一行为非文本块节点
            return nodes;
        }
    }
    return [
        node
    ];
}
var isParagraph = function(node) {
    var _node_type;
    return (node === null || node === void 0 ? void 0 : (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) === "paragraph";
};
// 插入块处理
function insertBlock(state, node) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        selection: null,
        cursorMove: true
    };
    if (!node.isBlock) {
        throw new Error("必须传入 block node");
    }
    var tr = state.tr, schema = state.schema;
    var selection = options.selection || state.selection;
    var cursorMove = options.cursorMove;
    var _schema_nodes = schema.nodes, table = _schema_nodes.table, note = _schema_nodes.note;
    var from = selection.from, $from = selection.$from;
    // TODO: 为什么需要清除格式
    tr.setStoredMarks([]); // 清除格式
    var insertingNodes = getInsertBlockNodes(state, node);
    // TODO: selection.replace 并不是常用的函数，是否可以替换成 tr.replaceWith
    selection.replace(tr, new Slice(Fragment.from(insertingNodes), 0, 0));
    // transform 1.1 版本会在 replace 过程中增加多余的空行，此处进行判断并清理
    // transform 升级到 1.3 之后可以恢复此段代码的处理，不需要清理多余的空行
    // https://ones.sankuai.com/ones/product/1859/workItem/defect/detail/20632944
    var step = tr.steps[0];
    if (step) {
        var slice = step === null || step === void 0 ? void 0 : step.slice;
        var content = (slice === null || slice === void 0 ? void 0 : slice.content).content;
        var size = content.length;
        // 末尾两个元素是否为 p 标签
        var removeParagraph = size > 2 && isParagraph(content[size - 1]) && isParagraph(content[size - 2]);
        if (removeParagraph) {
            // 如果替换时最后两个node都是 paragraph，说明有多余的空行，需要删除最后一个空行
            var lastPos = tr.mapping.map(step.to);
            tr.delete(lastPos - 2, lastPos);
        }
    }
    tr.setSelection(new TextSelection(tr.doc.resolve(tr.mapping.map(state.selection.from)), tr.doc.resolve(tr.mapping.map(state.selection.to))));
    // TODO:下面这段代码优化
    // 移动光标位置
    if (cursorMove) {
        var nodeBefore = $from.nodeBefore; // 光标前相邻节点
        var offset = nodeBefore ? 2 : 0;
        if (node.type.isLeaf) {
            offset += 1;
        } else if (node.type === note) {
            offset += 4;
        } else if (node.type === table) {
            offset += 3;
        }
        var newPos = selection.constructor.name === "GapCursor" ? from : from + offset;
        tr.setSelection(TextSelection.create(tr.doc, newPos));
    }
    return {
        transaction: tr
    };
}
var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var execAfterCommands = function(commands) {
    var someThingFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    return function() {
        for(var _len = arguments.length, cmdArgs = new Array(_len), _key = 0; _key < _len; _key++){
            cmdArgs[_key] = arguments[_key];
        }
        return function(state, dispatch, view) {
            var _ = commands.apply(void 0, _toConsumableArray(cmdArgs))(state, dispatch, view);
            someThingFn(_);
            return _;
        };
    };
};

var findParentNodeClosestToPos = function($pos, predicate) {
    for(var i = $pos.depth; i > 0; i--){
        var node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    }
};
var findParentNode = function(predicate) {
    return function(param) {
        var $from = param.$from;
        return findParentNodeClosestToPos($from, predicate);
    };
};

function insertNote(type) {
    return function(state, dispatch, view) {
        var schema = state.schema;
        var _schema_nodes = schema.nodes, note = _schema_nodes.note, note_title = _schema_nodes.note_title, note_content = _schema_nodes.note_content;
        var titleNode = note_title.createAndFill();
        var contentNode = note_content.createAndFill();
        var noteNode = note.create({
            type: type
        }, Fragment.from([
            titleNode,
            contentNode
        ]));
        var transaction = insertBlock(state, noteNode).transaction;
        var $from = transaction.selection.$from;
        var newSelection = TextSelection.findFrom($from, 1, true);
        dispatch(transaction.setSelection(newSelection).scrollIntoView());
        view.focus();
        return true;
    };
}

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-note-selected .ct-note{border-color:#fdc446}.ct-note-selected .ct-note[data-type=info]{border-color:#23bdd9}.ct-note-selected .ct-note[data-type=tip]{border-color:#53752d}.ct-note-selected .ct-note[data-type=warning]{border-color:#e75252}.ct-note{min-width:265px;min-height:42px;margin:8px 0;border:1px solid transparent;border-radius:4px;background-color:#fffbe6}.ct-note.ProseMirror-selectednode{border-color:#fdc446}.ct-note[data-type=info]{background-color:#e6ffff}.ct-note[data-type=info].ProseMirror-selectednode{border-color:#23bdd9}.ct-note[data-type=tip]{background-color:#f6ffed}.ct-note[data-type=tip].ProseMirror-selectednode{border-color:#53752d}.ct-note[data-type=warning]{background-color:#fff1f0}.ct-note[data-type=warning].ProseMirror-selectednode{border-color:#e75252}.ct-note.ProseMirror-selectednode{position:relative}.ct-note.ProseMirror-selectednode:after{z-index:2;position:absolute;content:"";left:-1px;right:-1px;top:-1px;bottom:-1px;background-color:#23bdd9;opacity:.2;pointer-events:none}.ct-note.ProseMirror-selectednode>.ct-note-content,.ct-note.ProseMirror-selectednode>.ct-note-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.hidden-title{background:#fffbe6 url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 10px 11px}.hidden-title>.ct-note-title{display:none}.hidden-title[data-type=info]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=tip]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.hidden-title[data-type=warning]{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-title{min-height:24px;padding:8px 0;font-size:14px;font-weight:700;color:#333;line-height:24px}.ct-note-title>.ct-note-title-text{position:relative;display:inline-block;min-height:24px;padding-left:36px;color:#333;line-height:24px;font-family:PingFangSC-Medium;font-size:13px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395614592%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223358%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23FDC446%22 p-id%3D%223359%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat;background-position:10px 3px}[data-type=info]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395638204%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223862%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m576 255.808c0-41.6-66.752-57.088-66.56-83.84V454.592C573.44 416.064 545.92 384 512 384c-45.44 0-97.024 25.344-97.024 48.576s35.584 11.968 35.584 46.528v204.8c0 26.24-66.56 41.6-66.56 83.904 0 0.448 256.768 0 256 0zM512 192a64 64 0 1 0 0 128 64 64 0 0 0 0-128z%22 fill%3D%22%233d91f2%22 p-id%3D%223863%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=tip]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395631927%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223694%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M550.4 573.76V601.6a38.4 38.4 0 0 1-76.8 0v-27.84c-45.952-13.312-72.192-52.16-72.96-109.248a38.4 38.4 0 0 1 76.8-0.96c0.448 30.4 8.128 38.528 34.56 38.528 26.432 0 34.112-8.128 34.56-38.528a38.4 38.4 0 1 1 76.8 0.96c-0.768 57.088-27.008 95.936-72.96 109.248zM512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64z m112 594.048A223.296 223.296 0 0 0 736 464a224 224 0 1 0-336 194.048v61.952a64 64 0 0 0 64 64h96a64 64 0 0 0 64-64v-61.952z%22 fill%3D%22%2370B123%22 p-id%3D%223695%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}[data-type=warning]>.ct-note-title>.ct-note-title-text{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221522395624224%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223526%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2218%22 height%3D%2218%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M64 512a448 448 0 1 1 896 0A448 448 0 0 1 64 512z m448-296.832c-37.376 0-67.2 30.08-67.2 67.008v270.848c0 36.544 30.08 67.008 67.2 67.008 37.376 0 67.2-30.016 67.2-67.008V282.24c0-36.48-30.08-67.008-67.2-67.008z m0 593.6a67.2 67.2 0 1 0 0-134.4 67.2 67.2 0 0 0 0 134.4z%22 fill%3D%22%23F05E50%22 p-id%3D%223527%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-note-content{padding:0 8px 0 36px}.ct-note-content p{margin:8px 0}';
styleInject(css_248z);

var IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
var Keycodes;
(function(Keycodes) {
    Keycodes[Keycodes["Enter"] = 13] = "Enter";
    Keycodes[Keycodes["BackSpace"] = 8] = "BackSpace";
    Keycodes[Keycodes["Tab"] = 9] = "Tab";
    Keycodes[Keycodes["Esc"] = 27] = "Esc";
    Keycodes[Keycodes["Space"] = 32] = "Space";
    Keycodes[Keycodes["Left"] = 37] = "Left";
    Keycodes[Keycodes["Up"] = 38] = "Up";
    Keycodes[Keycodes["Right"] = 39] = "Right";
    Keycodes[Keycodes["Down"] = 40] = "Down";
    Keycodes[Keycodes["Delete"] = 46] = "Delete";
    Keycodes[Keycodes["a"] = 65] = "a";
    Keycodes[Keycodes["c"] = 67] = "c";
    Keycodes[Keycodes["LeftBracket"] = 219] = "LeftBracket";
    Keycodes[Keycodes["RightBracket"] = 221] = "RightBracket";
    Keycodes[Keycodes["CompositionEnd"] = 229] = "CompositionEnd";
})(Keycodes || (Keycodes = {}));

var AFTER_INSERT = "after_insert";

function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
var getDOMOffset = function(param) {
    var offsetParent = param.offsetParent, target = param.target, height = param.height, popoverWidth = param.popoverWidth, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust;
    var top = 0;
    var left = 0;
    var right = "auto";
    var _target_getBoundingClientRect = target.getBoundingClientRect(), domLeft = _target_getBoundingClientRect.left, domTop = _target_getBoundingClientRect.top, domBottom = _target_getBoundingClientRect.bottom, domHeight = _target_getBoundingClientRect.height;
    var _offsetParent_querySelector_getBoundingClientRect = offsetParent.querySelector(".ProseMirror").getBoundingClientRect(), parentLeft = _offsetParent_querySelector_getBoundingClientRect.left, parentTop = _offsetParent_querySelector_getBoundingClientRect.top, parentRight = _offsetParent_querySelector_getBoundingClientRect.right;
    top = domTop - parentTop; // dom顶部距到父元素顶部距离
    left = domLeft - parentLeft; // dom距离页面左边距
    var avHeight = window.innerHeight;
    if (// 底部弹出后预留 50px 的空白区域
    bottomFirst && avHeight - domBottom - 50 > height || top < height && autoAdjust) {
        top = domBottom - parentTop + 2; // // dom底部距离页面到视口顶部距
    } else {
        top = top - height - 2;
    }
    // 右边剩余空间
    var rightWidth = parentRight - domLeft;
    if (rightWidth < popoverWidth) {
        left = "auto";
        right = 0;
    }
    if (left < 0) {
        left = 0;
        right = "auto";
    }
    return {
        left: left,
        top: top,
        right: right,
        height: height + domHeight
    };
};
var setPopoverStyle = function(param) {
    var $popover = param.$popover, target = param.target, height = param.height, bottomFirst = param.bottomFirst, autoAdjust = param.autoAdjust, customStyle = param.customStyle, offsetParent = param.offsetParent, popoverWidth = param.popoverWidth;
    $popover.style.display = "block";
    if (target) {
        if (!offsetParent || !$popover) {
            return;
        }
        var style = getDOMOffset({
            offsetParent: offsetParent,
            target: target,
            height: height,
            bottomFirst: bottomFirst,
            autoAdjust: autoAdjust,
            popoverWidth: popoverWidth
        });
        Object.entries(style).forEach(function(param) {
            var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
            if (/[0-9]+/.test(value)) {
                $popover.style[key] = "".concat(value, "px");
            } else {
                $popover.style[key] = "".concat(value);
            }
        });
    } else if (customStyle) {
        Object.keys(customStyle).forEach(function(key) {
            $popover.style[key] = customStyle[key];
        });
    }
};
var emptyDOM = function(renderDOM) {
    if (renderDOM.firstElementChild) {
        render(null, renderDOM);
    }
};
/**
 * 销毁动态挂载的元素
 */ var emptyNode = function emptyNode(node) {
    if (!node.firstChildElement) return;
    var unmountResult = ReactDOM.unmountComponentAtNode(node);
    if (unmountResult) {
        node.removeChild(node);
    }
};

var css_248z$1 = ".ct-popover{display:none;position:absolute;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;pointer-events:none;background:transparent;z-index:499;transition:opacity .2s ease}.ct-popover.resizing{height:-webkit-fit-content!important;height:-moz-fit-content!important;height:fit-content!important}.ct-popover .ct-toolbox{display:flex;top:0;flex-direction:row;align-items:center;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;pointer-events:all}.ct-popover .ct-toolbox.in-table{top:30px}.ct-popover .ct-popover-sticky{position:-webkit-sticky!important;position:sticky!important;top:0!important}.ct-popover.in-table{z-index:600}.ct-popover.in-table .ct-popover-sticky{top:36px!important}";
styleInject(css_248z$1);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var SHOW = "show";
var HIDE = "hide";
var Popover = /*#__PURE__*/ function() {
    function Popover(param) {
        var container = param.container, className = param.className, content = param.content, _param_bottomFirst = param.bottomFirst, bottomFirst = _param_bottomFirst === void 0 ? false : _param_bottomFirst, _param_autoAdjust = param.autoAdjust, autoAdjust = _param_autoAdjust === void 0 ? false : _param_autoAdjust, _param_isSticky = param.isSticky, isSticky = _param_isSticky === void 0 ? false : _param_isSticky;
        var _this = this;
        _classCallCheck(this, Popover);
        this.popoverState = HIDE;
        this.setPopoverState = function(state) {
            _this.popoverState = state;
        };
        this.isSticky = isSticky;
        this.bottomFirst = bottomFirst;
        this.autoAdjust = autoAdjust;
        this.$popover = document.createElement("div");
        this.$popover.className = "".concat(classNamePrefix("popover"), " ").concat(className || "");
        this.content = content;
        this.container = container;
        (container || document.body).appendChild(this.$popover);
    }
    var _proto = Popover.prototype;
    _proto.show = function show(param) {
        var target = param.target, // placement = "auto",
        content = param.content, height = param.height, customStyle = param.customStyle, _param_forceUpdate = param.forceUpdate, forceUpdate = _param_forceUpdate === void 0 ? false : _param_forceUpdate;
        var _this = this;
        if (this.popoverState === SHOW && !forceUpdate) {
            return;
        }
        if (!target || !_instanceof(target, HTMLElement)) {
            return;
        }
        if (this.popoverState === HIDE) {
            var offsetParent = this.container;
            var _this1 = this, bottomFirst = _this1.bottomFirst, autoAdjust = _this1.autoAdjust;
            setPopoverStyle({
                $popover: this.$popover,
                target: target,
                height: height,
                bottomFirst: bottomFirst,
                autoAdjust: autoAdjust,
                customStyle: customStyle,
                offsetParent: offsetParent,
                popoverWidth: this.popoverWidth
            });
        }
        if (forceUpdate) {
            emptyDOM(this.$popover);
        }
        this.content = content;
        if (typeof content === "function") {
            content = content();
        }
        if (target && target.closest(".".concat(classNamePrefix("table-wrapper")))) {
            this.$popover.classList.add("in-table");
        } else {
            this.$popover.classList.remove("in-table");
        }
        render(content, this.$popover, function() {
            if (_this.$popover.firstElementChild) {
                var $child = _this.$popover.firstElementChild;
                if (_this.isSticky) {
                    $child.classList.add(classNamePrefix("popover-sticky"));
                }
                _this.setPopoverState(SHOW);
            }
        });
    };
    _proto.hide = function hide() {
        if (this.popoverState === HIDE) {
            return;
        }
        this.popoverWidth = this.$popover.offsetWidth;
        emptyDOM(this.$popover);
        this.$popover.setAttribute("style", "");
        this.$popover.style.display = "none";
        this.setPopoverState(HIDE);
    };
    _proto.destroy = function destroy() {
        emptyNode(this.$popover);
        this.$popover.remove();
        this.$popover = null;
    };
    return Popover;
}();

function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var DEFAULT_HEIGHT = 34;
var DEFAULT_CONFNIG = {
    isSticky: false,
    bottomFirst: false,
    autoAdjust: false,
    updateOnDocChange: true
};
var PluginView = /*#__PURE__*/ function() {
    function PluginView(view, config) {
        _classCallCheck$1(this, PluginView);
        this.isShowing = false;
        this.view = view;
        this.config = _objectSpread({}, DEFAULT_CONFNIG, config || {});
    }
    var _proto = PluginView.prototype;
    _proto.update = function update(view, lastState) {
        var _this = this;
        var state = view.state;
        var updateOnDocChange = this.config.updateOnDocChange;
        if (updateOnDocChange && lastState && lastState.doc.eq(state.doc) && lastState.selection.eq(state.selection)) {
            return;
        }
        var foundNode = this.getNode(view, lastState);
        if (!foundNode || !_instanceof$1(foundNode, HTMLElement)) {
            this.hide();
            return;
        }
        setTimeout(function() {
            // 卸载并重新渲染 popover
            _this.hide();
            _this.show();
        // 使用 timer 防止 target 元素样式还未更新时就触发 size 计算
        }, 0);
    // this.show();
    };
    /**
   * 获取当前弹框的 DOM 节点
   */ _proto.getPopover = function getPopover() {
        return this.popover && this.popover.$popover;
    };
    _proto.destroy = function destroy() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.destroy();
        this.popover = null;
    };
    _proto.show = function show(lastState) {
        if (this.isShowing) {
            return;
        }
        var foundNode = this.getNode(this.view, lastState);
        if (foundNode) {
            this.isShowing = true;
            if (!this.popover) {
                this.popover = new Popover(_objectSpread({
                    container: this.view.dom.offsetParent
                }, this.config));
            }
            this.popover.show({
                target: foundNode,
                height: this.getHeight(),
                content: this.getContent()
            });
        }
    };
    _proto.hide = function hide() {
        var _this_popover;
        (_this_popover = this.popover) === null || _this_popover === void 0 ? void 0 : _this_popover.hide();
        this.isShowing = false;
    };
    /**
   * 返回弹框高度，用于根据自定义内容可重写
   */ _proto.getHeight = function getHeight() {
        return DEFAULT_HEIGHT;
    };
    return PluginView;
}();

var locale = "en";
var version = 16;
var cannot_search_user = "User not found, click space to complete input";
var load_fail_retry = "Failed to load, please try again later";
var pk_avatar = "avatar";
var mention_by_mis_name = "Can @user by name and MIS number";
var searching = "Searching...";
var pk_link_text = "Text";
var insert_blank = "Insert";
var pk_visit_link = "Access the link";
var pk_link_address = "Address";
var pk_link = "Link";
var cancel_blank = "Cancel";
var pk_link_change_tip = "Link text follows the Doc change";
var pk_edit_link = "Edit link";
var pk_link_text_tip = "Input the link text";
var pk_cancel_link = "Cancel link";
var save_blank = "Save";
var pk_link_address_tip = "Input the link address";
var border = "Border";
var pk_insert = "Insert";
var image_link = "Image Link";
var pk_retry = "Retry";
var pk_edit = "Edit";
var width = "Width";
var reupload = "Reupload";
var image_upload_fail1 = "Sorry, upload error!";
var right_address_tip = "Please input right address";
var image_upload_fail3 = "Otherwise, please click button below to retry.";
var image_upload_fail2 = "If the image is moved/pasted from outside, please download and reupload.";
var pk_confirm = "Confirm";
var input_html = "Enter HTML code.";
var formual = "Formual";
var pk_loading = "Loading...";
var click_to_expand = "Click to expand the content";
var pk_cancel = "Cancel";
var input_html_tip = "You can insert HTML code to embed corresponding content on a webpage.";
var input_latex = "Enter Latex code";
var insert_latex_tip = "You can insert Latex code to embed corresponding content within the page.";
var pk_title = "Title";
var wire_frame = "Wireframe";
var fill_in = "Fill";
var input_plantuml = "Enter PlantUML code.";
var border_style = "Border type";
var set_th_line = "Header Column";
var set_th_row = "Header Row";
var table_attr = "Table style";
var cancel_th_line = "Cancel Header Column";
var insert_line_right = "Right Insert Column";
var insert_row = "Delete Rows";
var split_cell = "Split cells";
var delete_line = "Delete Columns";
var pk_no = "No borders";
var input_markdown_tip = "You can insert Markdown code to embed corresponding content within the page.";
var confirm_blank = "Confirm";
var cancel_th_row = "Cancel Header Row";
var insert_row_above = "Insert Row Above";
var delete_table = "Delete";
var input_plantuml_tip = "You can insert PlantUML code to embed corresponding content within the page.";
var border_width = "Border width";
var input_markdown = "Enter Markdown code.";
var merge_cell = "Merge cells";
var set_line_num = "Show Row Number";
var border_color = "Border color";
var insert_line_left = "Left Insert Column";
var insert_row_below = "Insert Row Below";
var cancel_line_num = "Cancel Row Number";
var exit_data_lost_tip = "If you exit, any unsaved data will be lost.";
var if_exit_gantt = "Are you sure to exit the Gantt chart?";
var pk_gantt_loading = "Loading Gantt chart...";
var gantt_load_fail = "Gantt chart loading failed.";
var operate_error = "Invalid operation";
var gantt_keep_work_tip = "Please keep at least one task.";
var save_success = "Save successful";
var gantt_frame_load_fail = "Gantt chart framework failed to load.";
var pk_network_exception = "Network exception";
var save_fail = "Save failed";
var pk_saving = "Saving...";
var gantt_plugin_fail = "Gantt chart editing plugin failed to start.";
var gantt_editing_tip = "Editing Gantt Chart, please wait a moment.";
var pk_discard = "Drop";
var pk_zoom_in = "Zoom in";
var pk_zoom_out = "Zoom out";
var pk_use = "Use";
var draft_edit_tip = "There is a draft that was edited but not saved on {time}. Do you want to continue editing?";
var if_use_local_draft = "Do you use local drafts?";
var pk_load_fail = "Loading failed";
var pk_this_time = "Now";
var choose_time = "Select time";
var pk_hh_mm_ss = "hh:mm:ss A";
var pk_y_d = "MM-DD-YYYY";
var pk_y_d_ts = "MM-DD-YYYY hh:mm:ss A";
var pk_text = "Text";
var h1 = "Heading 1";
var h2 = "Heading 2";
var h3 = "Heading 3";
var h4 = "Heading 4";
var h5 = "Heading 5";
var h6 = "Heading 6";
var pk_catalog = "Catalog";
var page_view_load_fail_click = "Directory tree loading failed. Please click to reload.";
var page_tree_no_sub_doc = "No sub documents found in this directory";
var page_tree_no_perm = "No permission to view the directory tree.";
var pk_load_fail_retry = "Loading failed, please click to reload.";
var loading2 = "Loading";
var page_tree_deleted = "The directory tree has been deleted.";
var pk_pause = "Pause";
var pk_mute = "Mute";
var pk_untitled = "Untitled";
var pk_play = "Play";
var adjust_volume = "Adjust volume";
var download_fail_retry = "Download failed please retry";
var pk_download = "Download";
var get_file_fail = "Failed to get file";
var pk_network_fail = "Network connection failed";
var pk_upload_fail = "Upload failed";
var audio_not_support_tip = "This browser does not support the HTML5 audio tag.";
var pk_volume = "Volume";
var browser_not_support_tip = "This browser does not support the HTML5 video tag.";
var pk_zoom_in2 = "Zoom in";
var video_upload_tip = "Video is being transcoded, if the file is large, it may take a long time. Please wait patiently...";
var pk_video = "Video";
var pk_zoom_out2 = "Zoom out";
var space_update_fail_tip = "Space update acquisition failed. Click to retry.";
var pk_recent_update = "Recent Updates";
var show_more = "Show More";
var no_space_update = "No Updates in Space.";
var pk_restore = "Restore";
var en_parker = {
    locale: locale,
    version: version,
    cannot_search_user: cannot_search_user,
    load_fail_retry: load_fail_retry,
    pk_avatar: pk_avatar,
    mention_by_mis_name: mention_by_mis_name,
    searching: searching,
    pk_link_text: pk_link_text,
    insert_blank: insert_blank,
    pk_visit_link: pk_visit_link,
    pk_link_address: pk_link_address,
    pk_link: pk_link,
    cancel_blank: cancel_blank,
    pk_link_change_tip: pk_link_change_tip,
    pk_edit_link: pk_edit_link,
    pk_link_text_tip: pk_link_text_tip,
    pk_cancel_link: pk_cancel_link,
    save_blank: save_blank,
    pk_link_address_tip: pk_link_address_tip,
    border: border,
    pk_insert: pk_insert,
    image_link: image_link,
    pk_retry: pk_retry,
    pk_edit: pk_edit,
    width: width,
    reupload: reupload,
    image_upload_fail1: image_upload_fail1,
    right_address_tip: right_address_tip,
    image_upload_fail3: image_upload_fail3,
    image_upload_fail2: image_upload_fail2,
    pk_confirm: pk_confirm,
    input_html: input_html,
    formual: formual,
    pk_loading: pk_loading,
    click_to_expand: click_to_expand,
    pk_cancel: pk_cancel,
    input_html_tip: input_html_tip,
    input_latex: input_latex,
    insert_latex_tip: insert_latex_tip,
    pk_title: pk_title,
    wire_frame: wire_frame,
    fill_in: fill_in,
    input_plantuml: input_plantuml,
    border_style: border_style,
    set_th_line: set_th_line,
    set_th_row: set_th_row,
    table_attr: table_attr,
    cancel_th_line: cancel_th_line,
    insert_line_right: insert_line_right,
    insert_row: insert_row,
    split_cell: split_cell,
    delete_line: delete_line,
    pk_no: pk_no,
    input_markdown_tip: input_markdown_tip,
    confirm_blank: confirm_blank,
    cancel_th_row: cancel_th_row,
    insert_row_above: insert_row_above,
    delete_table: delete_table,
    input_plantuml_tip: input_plantuml_tip,
    border_width: border_width,
    input_markdown: input_markdown,
    merge_cell: merge_cell,
    set_line_num: set_line_num,
    border_color: border_color,
    insert_line_left: insert_line_left,
    insert_row_below: insert_row_below,
    cancel_line_num: cancel_line_num,
    exit_data_lost_tip: exit_data_lost_tip,
    if_exit_gantt: if_exit_gantt,
    pk_gantt_loading: pk_gantt_loading,
    gantt_load_fail: gantt_load_fail,
    operate_error: operate_error,
    gantt_keep_work_tip: gantt_keep_work_tip,
    save_success: save_success,
    gantt_frame_load_fail: gantt_frame_load_fail,
    pk_network_exception: pk_network_exception,
    save_fail: save_fail,
    pk_saving: pk_saving,
    gantt_plugin_fail: gantt_plugin_fail,
    gantt_editing_tip: gantt_editing_tip,
    pk_discard: pk_discard,
    pk_zoom_in: pk_zoom_in,
    pk_zoom_out: pk_zoom_out,
    pk_use: pk_use,
    draft_edit_tip: draft_edit_tip,
    if_use_local_draft: if_use_local_draft,
    pk_load_fail: pk_load_fail,
    pk_this_time: pk_this_time,
    choose_time: choose_time,
    pk_hh_mm_ss: pk_hh_mm_ss,
    pk_y_d: pk_y_d,
    pk_y_d_ts: pk_y_d_ts,
    pk_text: pk_text,
    h1: h1,
    h2: h2,
    h3: h3,
    h4: h4,
    h5: h5,
    h6: h6,
    pk_catalog: pk_catalog,
    page_view_load_fail_click: page_view_load_fail_click,
    page_tree_no_sub_doc: page_tree_no_sub_doc,
    page_tree_no_perm: page_tree_no_perm,
    pk_load_fail_retry: pk_load_fail_retry,
    loading2: loading2,
    page_tree_deleted: page_tree_deleted,
    pk_pause: pk_pause,
    pk_mute: pk_mute,
    pk_untitled: pk_untitled,
    pk_play: pk_play,
    adjust_volume: adjust_volume,
    download_fail_retry: download_fail_retry,
    pk_download: pk_download,
    get_file_fail: get_file_fail,
    pk_network_fail: pk_network_fail,
    pk_upload_fail: pk_upload_fail,
    audio_not_support_tip: audio_not_support_tip,
    pk_volume: pk_volume,
    browser_not_support_tip: browser_not_support_tip,
    pk_zoom_in2: pk_zoom_in2,
    video_upload_tip: video_upload_tip,
    pk_video: pk_video,
    pk_zoom_out2: pk_zoom_out2,
    space_update_fail_tip: space_update_fail_tip,
    pk_recent_update: pk_recent_update,
    show_more: show_more,
    no_space_update: no_space_update,
    pk_restore: pk_restore
};

var locale$1 = "zh";
var version$1 = 16;
var cannot_search_user$1 = "未搜索到用户，点击空格完成输入";
var load_fail_retry$1 = "加载失败，请稍后重试";
var pk_avatar$1 = "头像";
var mention_by_mis_name$1 = "可通过姓名及mis号@用户";
var searching$1 = "搜索中...";
var pk_link_text$1 = "链接文字";
var insert_blank$1 = "插 入";
var pk_link$1 = "链接";
var pk_link_address$1 = "链接地址";
var pk_visit_link$1 = "访问链接";
var cancel_blank$1 = "取 消";
var pk_link_change_tip$1 = "链接文字跟随文档标题变更";
var pk_edit_link$1 = "编辑链接";
var pk_cancel_link$1 = "取消链接";
var pk_link_text_tip$1 = "请输入链接文字";
var save_blank$1 = "保 存";
var pk_link_address_tip$1 = "请输入链接地址";
var border$1 = "边框";
var pk_insert$1 = "插入";
var image_link$1 = "图片链接";
var pk_edit$1 = "编辑";
var pk_retry$1 = "重试";
var width$1 = "宽度";
var reupload$1 = "重新上传";
var image_upload_fail1$1 = "抱歉，图片上传失败！";
var image_upload_fail3$1 = "否则，请点击下方按钮进行重试。";
var right_address_tip$1 = "请输入正确的地址";
var image_upload_fail2$1 = "如果是从外部拖动、粘贴过来的图片，请下载原图并重新上传。";
var pk_confirm$1 = "确定";
var input_html$1 = "输入HTML代码";
var formual$1 = "公式";
var pk_loading$1 = "正在加载中...";
var pk_cancel$1 = "取消";
var click_to_expand$1 = "点击展开内容";
var input_html_tip$1 = "可以插入HTML代码，以在页面内嵌入相应内容：";
var insert_latex_tip$1 = "可以插入Latex代码，以在页面内嵌入相应内容：";
var input_latex$1 = "输入Latex代码";
var pk_title$1 = "标题";
var wire_frame$1 = "线框";
var fill_in$1 = "填充";
var input_plantuml$1 = "輸入PlantUML代碼";
var border_style$1 = "边框样式";
var set_th_row$1 = "设置表头行";
var set_th_line$1 = "设置表头列";
var table_attr$1 = "表格属性";
var cancel_th_line$1 = "取消表头列";
var insert_row$1 = "删除行";
var insert_line_right$1 = "右侧插入列";
var split_cell$1 = "拆分单元格";
var delete_line$1 = "删除列";
var confirm_blank$1 = "确 定";
var input_markdown_tip$1 = "可以插入Markdown代码，以在页面内嵌入相应内容：";
var pk_no$1 = "无";
var cancel_th_row$1 = "取消表头行";
var insert_row_above$1 = "上方插入行";
var delete_table$1 = "删除表格";
var input_plantuml_tip$1 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容";
var border_width$1 = "边框宽度";
var input_markdown$1 = "输入Markdown代码";
var merge_cell$1 = "合并单元格";
var set_line_num$1 = "设置行号列";
var border_color$1 = "边框颜色";
var insert_line_left$1 = "左侧插入列";
var insert_row_below$1 = "下方插入行";
var cancel_line_num$1 = "取消行号列";
var if_exit_gantt$1 = "确定退出甘特图?";
var exit_data_lost_tip$1 = "退出后，尚未保存的数据将丢失。";
var gantt_load_fail$1 = "甘特图载入失败";
var pk_gantt_loading$1 = "甘特图载入中...";
var operate_error$1 = "您的操作有误";
var gantt_keep_work_tip$1 = "请至少保留一个任务";
var gantt_frame_load_fail$1 = "甘特图框架加载失败";
var save_success$1 = "保存成功";
var save_fail$1 = "保存失败";
var pk_network_exception$1 = "网络异常";
var pk_saving$1 = "正在保存中...";
var gantt_plugin_fail$1 = "甘特图编辑插件启动失败";
var gantt_editing_tip$1 = "正在编辑甘特图，请稍候再试噢。";
var pk_discard$1 = "废弃";
var pk_zoom_in$1 = "放大查看";
var pk_zoom_out$1 = "缩小查看";
var pk_use$1 = "使用";
var draft_edit_tip$1 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继续编辑";
var pk_load_fail$1 = "加载失败";
var if_use_local_draft$1 = "是否使用本地草稿？";
var pk_this_time$1 = "此刻";
var choose_time$1 = "选择时间";
var pk_hh_mm_ss$1 = "HH:mm:ss";
var pk_y_d$1 = "YYYY-MM-DD";
var pk_y_d_ts$1 = "YYYY-MM-DD HH:mm:ss";
var pk_text$1 = "正文";
var h1$1 = "标题 1";
var h2$1 = "标题 2";
var h3$1 = "标题 3";
var h4$1 = "标题 4";
var h5$1 = "标题 5";
var h6$1 = "标题 6";
var pk_catalog$1 = "目录";
var page_view_load_fail_click$1 = "目录树加载失败，请点击重新加载";
var page_tree_no_sub_doc$1 = "该目录下暂无子文档";
var page_tree_no_perm$1 = "无权查看该目录树";
var pk_load_fail_retry$1 = "加载失败，请点击重新加载";
var loading2$1 = "正在加载";
var page_tree_deleted$1 = "该目录树已被删除";
var pk_pause$1 = "暂停";
var pk_mute$1 = "静音";
var pk_untitled$1 = "未命名";
var pk_play$1 = "播放";
var adjust_volume$1 = "音量调节";
var download_fail_retry$1 = "下载失败，请重试";
var get_file_fail$1 = "文件获取失败";
var pk_download$1 = "下载";
var pk_network_fail$1 = "网络连接失败";
var pk_upload_fail$1 = "上传失败";
var audio_not_support_tip$1 = "本浏览器不支持 HTML5 audio 标签";
var browser_not_support_tip$1 = "本浏览器不支持 HTML5 video 标签";
var pk_volume$1 = "音量";
var pk_zoom_in2$1 = "放大";
var pk_video$1 = "视频";
var video_upload_tip$1 = "视频正在转码中，如文件较大可能时间较长，请耐心等待…";
var pk_zoom_out2$1 = "缩小";
var space_update_fail_tip$1 = "空间更新获取失败，点击重试";
var pk_recent_update$1 = "最近更新";
var show_more$1 = "显示更多";
var no_space_update$1 = "空间暂时没有动态～";
var pk_restore$1 = "恢复默认";
var zh_parker = {
    locale: locale$1,
    version: version$1,
    cannot_search_user: cannot_search_user$1,
    load_fail_retry: load_fail_retry$1,
    pk_avatar: pk_avatar$1,
    mention_by_mis_name: mention_by_mis_name$1,
    searching: searching$1,
    pk_link_text: pk_link_text$1,
    insert_blank: insert_blank$1,
    pk_link: pk_link$1,
    pk_link_address: pk_link_address$1,
    pk_visit_link: pk_visit_link$1,
    cancel_blank: cancel_blank$1,
    pk_link_change_tip: pk_link_change_tip$1,
    pk_edit_link: pk_edit_link$1,
    pk_cancel_link: pk_cancel_link$1,
    pk_link_text_tip: pk_link_text_tip$1,
    save_blank: save_blank$1,
    pk_link_address_tip: pk_link_address_tip$1,
    border: border$1,
    pk_insert: pk_insert$1,
    image_link: image_link$1,
    pk_edit: pk_edit$1,
    pk_retry: pk_retry$1,
    width: width$1,
    reupload: reupload$1,
    image_upload_fail1: image_upload_fail1$1,
    image_upload_fail3: image_upload_fail3$1,
    right_address_tip: right_address_tip$1,
    image_upload_fail2: image_upload_fail2$1,
    pk_confirm: pk_confirm$1,
    input_html: input_html$1,
    formual: formual$1,
    pk_loading: pk_loading$1,
    pk_cancel: pk_cancel$1,
    click_to_expand: click_to_expand$1,
    input_html_tip: input_html_tip$1,
    insert_latex_tip: insert_latex_tip$1,
    input_latex: input_latex$1,
    pk_title: pk_title$1,
    wire_frame: wire_frame$1,
    fill_in: fill_in$1,
    input_plantuml: input_plantuml$1,
    border_style: border_style$1,
    set_th_row: set_th_row$1,
    set_th_line: set_th_line$1,
    table_attr: table_attr$1,
    cancel_th_line: cancel_th_line$1,
    insert_row: insert_row$1,
    insert_line_right: insert_line_right$1,
    split_cell: split_cell$1,
    delete_line: delete_line$1,
    confirm_blank: confirm_blank$1,
    input_markdown_tip: input_markdown_tip$1,
    pk_no: pk_no$1,
    cancel_th_row: cancel_th_row$1,
    insert_row_above: insert_row_above$1,
    delete_table: delete_table$1,
    input_plantuml_tip: input_plantuml_tip$1,
    border_width: border_width$1,
    input_markdown: input_markdown$1,
    merge_cell: merge_cell$1,
    set_line_num: set_line_num$1,
    border_color: border_color$1,
    insert_line_left: insert_line_left$1,
    insert_row_below: insert_row_below$1,
    cancel_line_num: cancel_line_num$1,
    if_exit_gantt: if_exit_gantt$1,
    exit_data_lost_tip: exit_data_lost_tip$1,
    gantt_load_fail: gantt_load_fail$1,
    pk_gantt_loading: pk_gantt_loading$1,
    operate_error: operate_error$1,
    gantt_keep_work_tip: gantt_keep_work_tip$1,
    gantt_frame_load_fail: gantt_frame_load_fail$1,
    save_success: save_success$1,
    save_fail: save_fail$1,
    pk_network_exception: pk_network_exception$1,
    pk_saving: pk_saving$1,
    gantt_plugin_fail: gantt_plugin_fail$1,
    gantt_editing_tip: gantt_editing_tip$1,
    pk_discard: pk_discard$1,
    pk_zoom_in: pk_zoom_in$1,
    pk_zoom_out: pk_zoom_out$1,
    pk_use: pk_use$1,
    draft_edit_tip: draft_edit_tip$1,
    pk_load_fail: pk_load_fail$1,
    if_use_local_draft: if_use_local_draft$1,
    pk_this_time: pk_this_time$1,
    choose_time: choose_time$1,
    pk_hh_mm_ss: pk_hh_mm_ss$1,
    pk_y_d: pk_y_d$1,
    pk_y_d_ts: pk_y_d_ts$1,
    pk_text: pk_text$1,
    h1: h1$1,
    h2: h2$1,
    h3: h3$1,
    h4: h4$1,
    h5: h5$1,
    h6: h6$1,
    pk_catalog: pk_catalog$1,
    page_view_load_fail_click: page_view_load_fail_click$1,
    page_tree_no_sub_doc: page_tree_no_sub_doc$1,
    page_tree_no_perm: page_tree_no_perm$1,
    pk_load_fail_retry: pk_load_fail_retry$1,
    loading2: loading2$1,
    page_tree_deleted: page_tree_deleted$1,
    pk_pause: pk_pause$1,
    pk_mute: pk_mute$1,
    pk_untitled: pk_untitled$1,
    pk_play: pk_play$1,
    adjust_volume: adjust_volume$1,
    download_fail_retry: download_fail_retry$1,
    get_file_fail: get_file_fail$1,
    pk_download: pk_download$1,
    pk_network_fail: pk_network_fail$1,
    pk_upload_fail: pk_upload_fail$1,
    audio_not_support_tip: audio_not_support_tip$1,
    browser_not_support_tip: browser_not_support_tip$1,
    pk_volume: pk_volume$1,
    pk_zoom_in2: pk_zoom_in2$1,
    pk_video: pk_video$1,
    video_upload_tip: video_upload_tip$1,
    pk_zoom_out2: pk_zoom_out2$1,
    space_update_fail_tip: space_update_fail_tip$1,
    pk_recent_update: pk_recent_update$1,
    show_more: show_more$1,
    no_space_update: no_space_update$1,
    pk_restore: pk_restore$1
};

var locale$2 = "zh-HK";
var version$2 = 16;
var cannot_search_user$2 = "未能找到用户，請按空格鍵完成輸入";
var load_fail_retry$2 = "載入失敗，請稍後重試。";
var pk_avatar$2 = "頭像";
var mention_by_mis_name$2 = "可通過姓名及MIS號碼@用戶";
var searching$2 = "搜尋中...";
var pk_link_text$2 = "鏈接文字";
var insert_blank$2 = "插 入";
var pk_visit_link$2 = "访问鏈接";
var pk_link_address$2 = "鏈接地址";
var pk_link$2 = "鏈接";
var cancel_blank$2 = "取 消";
var pk_link_change_tip$2 = "鏈接文字跟隨文件標題變更";
var pk_edit_link$2 = "編輯鏈接";
var pk_link_text_tip$2 = "請輸入鏈接文字";
var pk_cancel_link$2 = "取消鏈接";
var save_blank$2 = "保 存";
var pk_link_address_tip$2 = "請輸入鏈接地址";
var border$2 = "邊框";
var pk_insert$2 = "插入";
var image_link$2 = "圖片鏈接";
var pk_retry$2 = "重試";
var pk_edit$2 = "編輯";
var width$2 = "寬度";
var reupload$2 = "重新上傳";
var image_upload_fail1$2 = "抱歉，圖片上傳失敗！";
var right_address_tip$2 = "請輸入正確的地址";
var image_upload_fail3$2 = "否則，請按下方按鈕進行重試。";
var image_upload_fail2$2 = "如果您從外部拖動、粘貼過來的圖片，請下載原圖並重新上傳。";
var pk_confirm$2 = "確定";
var input_html$2 = "輸入HTML代碼";
var formual$2 = "公式";
var pk_loading$2 = "正在載入中...";
var pk_cancel$2 = "取消";
var click_to_expand$2 = "點選展開內容";
var input_html_tip$2 = "可以插入HTML代碼，以在頁面內嵌入相應內容：";
var insert_latex_tip$2 = "可以插入Latex代碼，以在頁面內嵌入相應內容：";
var input_latex$2 = "输入LaTeX代码";
var pk_title$2 = "標題";
var wire_frame$2 = "線框";
var fill_in$2 = "填充";
var input_plantuml$2 = "輸入PlantUML程式碼";
var border_style$2 = "邊框樣式";
var set_th_row$2 = "設置表頭行";
var set_th_line$2 = "設置表頭列";
var table_attr$2 = "表格屬性";
var cancel_th_line$2 = "取消表頭列";
var insert_row$2 = "删除行";
var insert_line_right$2 = "右側插入列";
var split_cell$2 = "拆分儲存格";
var delete_line$2 = "删除列";
var pk_no$2 = "無";
var confirm_blank$2 = "確 定";
var input_markdown_tip$2 = "可以插入Markdown代碼，以在頁面內嵌入相應內容：";
var cancel_th_row$2 = "取消表頭行";
var insert_row_above$2 = "上方插入行";
var delete_table$2 = "刪除表格";
var input_plantuml_tip$2 = "可以插入PlantUML代碼，以在頁面內嵌入相應內容：";
var border_width$2 = "邊框寬度";
var input_markdown$2 = "輸入Markdown代碼";
var merge_cell$2 = "合併儲存格";
var set_line_num$2 = "設置行号列";
var border_color$2 = "邊框顏色";
var insert_line_left$2 = "左側插入列";
var insert_row_below$2 = "下方插入行";
var cancel_line_num$2 = "取消行号列";
var if_exit_gantt$2 = "確定退出甘特圖?";
var exit_data_lost_tip$2 = "退出後，尚未儲存的數據將會遺失。";
var pk_gantt_loading$2 = "甘特圖載入中...";
var gantt_load_fail$2 = "甘特圖載入失敗";
var operate_error$2 = "您的操作有誤";
var gantt_keep_work_tip$2 = "請至少保留一個任務";
var save_success$2 = "保存成功";
var gantt_frame_load_fail$2 = "甘特圖框架載入失敗";
var save_fail$2 = "保存失敗";
var pk_network_exception$2 = "網絡異常";
var pk_saving$2 = "正在儲存中...";
var gantt_plugin_fail$2 = "甘特圖編輯插件啟動失敗。";
var gantt_editing_tip$2 = "正在編輯甘特圖，請稍後再試唷。";
var pk_discard$2 = "廢棄";
var pk_zoom_in$2 = "放大查看";
var pk_zoom_out$2 = "縮小查看";
var pk_use$2 = "使用";
var draft_edit_tip$2 = "存在一份于&nbsp;{time}&nbsp;进行了编辑但未保存的草稿，是否继續編輯";
var pk_load_fail$2 = "加載失敗";
var if_use_local_draft$2 = "是否使用本地草稿？";
var pk_this_time$2 = "此刻";
var choose_time$2 = "選擇時間";
var pk_hh_mm_ss$2 = "HH:mm:ss";
var pk_y_d$2 = "YYYY-MM-DD";
var pk_y_d_ts$2 = "YYYY-MM-DD HH:mm:ss";
var pk_text$2 = "正文";
var h1$2 = "標題 1";
var h2$2 = "標題 2";
var h3$2 = "標題 3";
var h4$2 = "標題 4";
var h5$2 = "標題 5";
var h6$2 = "標題 6";
var pk_catalog$2 = "目錄";
var page_view_load_fail_click$2 = "目錄樹加載失敗，請點擊重新加載。";
var page_tree_no_sub_doc$2 = "該目錄下暫無子文檔。";
var page_tree_no_perm$2 = "無權查看該目錄樹";
var pk_load_fail_retry$2 = "加載失敗，請點擊重新加載。";
var loading2$2 = "正在載入";
var page_tree_deleted$2 = "該目錄樹已被刪除";
var pk_pause$2 = "暫停";
var pk_mute$2 = "靜音";
var pk_untitled$2 = "未命名";
var pk_play$2 = "播放";
var adjust_volume$2 = "音量調節";
var download_fail_retry$2 = "下載失敗，請重試";
var pk_download$2 = "下載";
var get_file_fail$2 = "文件獲取失敗";
var pk_network_fail$2 = "網絡連接失敗";
var pk_upload_fail$2 = "上載失敗";
var audio_not_support_tip$2 = "本瀏覽器不支援 HTML5 audio 標籤";
var pk_volume$2 = "音量";
var browser_not_support_tip$2 = "本瀏覽器不支援 HTML5 video 標籤";
var pk_zoom_in2$2 = "放大";
var video_upload_tip$2 = "視頻正在轉碼中，如果文件較大可能需要較長的時間，請耐心等待...";
var pk_video$2 = "視頻";
var pk_zoom_out2$2 = "縮小";
var space_update_fail_tip$2 = "空間更新獲取失敗，點擊重試";
var pk_recent_update$2 = "最近更新";
var show_more$2 = "顯示更多";
var no_space_update$2 = "空間暫時沒有動態～";
var pk_restore$2 = "恢復預設";
var zhHK_parker = {
    locale: locale$2,
    version: version$2,
    cannot_search_user: cannot_search_user$2,
    load_fail_retry: load_fail_retry$2,
    pk_avatar: pk_avatar$2,
    mention_by_mis_name: mention_by_mis_name$2,
    searching: searching$2,
    pk_link_text: pk_link_text$2,
    insert_blank: insert_blank$2,
    pk_visit_link: pk_visit_link$2,
    pk_link_address: pk_link_address$2,
    pk_link: pk_link$2,
    cancel_blank: cancel_blank$2,
    pk_link_change_tip: pk_link_change_tip$2,
    pk_edit_link: pk_edit_link$2,
    pk_link_text_tip: pk_link_text_tip$2,
    pk_cancel_link: pk_cancel_link$2,
    save_blank: save_blank$2,
    pk_link_address_tip: pk_link_address_tip$2,
    border: border$2,
    pk_insert: pk_insert$2,
    image_link: image_link$2,
    pk_retry: pk_retry$2,
    pk_edit: pk_edit$2,
    width: width$2,
    reupload: reupload$2,
    image_upload_fail1: image_upload_fail1$2,
    right_address_tip: right_address_tip$2,
    image_upload_fail3: image_upload_fail3$2,
    image_upload_fail2: image_upload_fail2$2,
    pk_confirm: pk_confirm$2,
    input_html: input_html$2,
    formual: formual$2,
    pk_loading: pk_loading$2,
    pk_cancel: pk_cancel$2,
    click_to_expand: click_to_expand$2,
    input_html_tip: input_html_tip$2,
    insert_latex_tip: insert_latex_tip$2,
    input_latex: input_latex$2,
    pk_title: pk_title$2,
    wire_frame: wire_frame$2,
    fill_in: fill_in$2,
    input_plantuml: input_plantuml$2,
    border_style: border_style$2,
    set_th_row: set_th_row$2,
    set_th_line: set_th_line$2,
    table_attr: table_attr$2,
    cancel_th_line: cancel_th_line$2,
    insert_row: insert_row$2,
    insert_line_right: insert_line_right$2,
    split_cell: split_cell$2,
    delete_line: delete_line$2,
    pk_no: pk_no$2,
    confirm_blank: confirm_blank$2,
    input_markdown_tip: input_markdown_tip$2,
    cancel_th_row: cancel_th_row$2,
    insert_row_above: insert_row_above$2,
    delete_table: delete_table$2,
    input_plantuml_tip: input_plantuml_tip$2,
    border_width: border_width$2,
    input_markdown: input_markdown$2,
    merge_cell: merge_cell$2,
    set_line_num: set_line_num$2,
    border_color: border_color$2,
    insert_line_left: insert_line_left$2,
    insert_row_below: insert_row_below$2,
    cancel_line_num: cancel_line_num$2,
    if_exit_gantt: if_exit_gantt$2,
    exit_data_lost_tip: exit_data_lost_tip$2,
    pk_gantt_loading: pk_gantt_loading$2,
    gantt_load_fail: gantt_load_fail$2,
    operate_error: operate_error$2,
    gantt_keep_work_tip: gantt_keep_work_tip$2,
    save_success: save_success$2,
    gantt_frame_load_fail: gantt_frame_load_fail$2,
    save_fail: save_fail$2,
    pk_network_exception: pk_network_exception$2,
    pk_saving: pk_saving$2,
    gantt_plugin_fail: gantt_plugin_fail$2,
    gantt_editing_tip: gantt_editing_tip$2,
    pk_discard: pk_discard$2,
    pk_zoom_in: pk_zoom_in$2,
    pk_zoom_out: pk_zoom_out$2,
    pk_use: pk_use$2,
    draft_edit_tip: draft_edit_tip$2,
    pk_load_fail: pk_load_fail$2,
    if_use_local_draft: if_use_local_draft$2,
    pk_this_time: pk_this_time$2,
    choose_time: choose_time$2,
    pk_hh_mm_ss: pk_hh_mm_ss$2,
    pk_y_d: pk_y_d$2,
    pk_y_d_ts: pk_y_d_ts$2,
    pk_text: pk_text$2,
    h1: h1$2,
    h2: h2$2,
    h3: h3$2,
    h4: h4$2,
    h5: h5$2,
    h6: h6$2,
    pk_catalog: pk_catalog$2,
    page_view_load_fail_click: page_view_load_fail_click$2,
    page_tree_no_sub_doc: page_tree_no_sub_doc$2,
    page_tree_no_perm: page_tree_no_perm$2,
    pk_load_fail_retry: pk_load_fail_retry$2,
    loading2: loading2$2,
    page_tree_deleted: page_tree_deleted$2,
    pk_pause: pk_pause$2,
    pk_mute: pk_mute$2,
    pk_untitled: pk_untitled$2,
    pk_play: pk_play$2,
    adjust_volume: adjust_volume$2,
    download_fail_retry: download_fail_retry$2,
    pk_download: pk_download$2,
    get_file_fail: get_file_fail$2,
    pk_network_fail: pk_network_fail$2,
    pk_upload_fail: pk_upload_fail$2,
    audio_not_support_tip: audio_not_support_tip$2,
    pk_volume: pk_volume$2,
    browser_not_support_tip: browser_not_support_tip$2,
    pk_zoom_in2: pk_zoom_in2$2,
    video_upload_tip: video_upload_tip$2,
    pk_video: pk_video$2,
    pk_zoom_out2: pk_zoom_out2$2,
    space_update_fail_tip: space_update_fail_tip$2,
    pk_recent_update: pk_recent_update$2,
    show_more: show_more$2,
    no_space_update: no_space_update$2,
    pk_restore: pk_restore$2
};

// This file was auto generated by resource-sync tools.
var resources = {
    "en": {
        parker: en_parker
    },
    "zh": {
        parker: zh_parker
    },
    "zh-HK": {
        parker: zhHK_parker
    }
};

function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var I18nManager = /*#__PURE__*/ function() {
    function I18nManager() {
        _classCallCheck$2(this, I18nManager);
    }
    I18nManager.getInstance = function getInstance() {
        if (this.instance === null) {
            this.instance = createInstance();
            this.instance.init({
                // lng: 'zh',
                fallbackLng: "zh",
                ns: [
                    "parker"
                ],
                defaultNS: "parker",
                resources: resources,
                interpolation: {
                    escapeValue: false
                },
                react: {
                    useSuspense: false
                }
            });
            window.parkerI18nClient = this.instance;
        }
        return this.instance;
    };
    return I18nManager;
}();
I18nManager.instance = null;
var i18nClient = I18nManager.getInstance();

var css_248z$2 = ".ct-button{height:32px;border:1px solid rgba(0,0,0,.13);border-radius:4px;box-sizing:border-box;min-width:80px;font-size:14px;font-family:PingFangSC-Regular;color:rgba(0,0,0,.87);margin-left:12px;cursor:pointer;transition:all .3s}.ct-button:hover{border:1px solid #1c6cdc;color:#1c6cdc}.ct-button:active{color:#1253b5;border:1px solid #1253b5}.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button[disabled]:active,.ct-button[disabled]:hover{border:1px solid rgba(0,0,0,.13);color:rgba(0,0,0,.87)}.ct-button-primary.ct-button{border:1px solid #1c6cdc;background:#1c6cdc;color:#fff}.ct-button-primary.ct-button[disabled]{cursor:not-allowed;opacity:.45}.ct-button-primary.ct-button[disabled]:active,.ct-button-primary.ct-button[disabled]:hover{background:#1c6cdc;color:#fff}.ct-button-primary.ct-button:hover{border:1px solid #3d91f2;background:#3d91f2;color:#fff}.ct-button-primary.ct-button:active{border:1px solid #1253b5;background:#1253b5;color:#fff}.ct-button-danger{background:#e75252;color:#fff}.ct-button-disabled{opacity:.45;cursor:not-allowed}";
styleInject(css_248z$2);

var css_248z$3 = '.ct-base-modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:1002}.ct-base-modal .mask{position:absolute;top:0;left:0;right:0;bottom:0}.ct-base-modal-header{height:58px;padding:16px 24px;border-radius:4px 4px 0 0;background-color:#fff;line-height:26px;color:rgba(0,0,0,.87)}.ct-base-modal-header-title{font-size:18px;font-family:PingFangSC-Medium}.ct-base-modal-header-close{position:absolute;width:28px;height:28px;top:15px;right:20px;background:#fff;transition:all .3s;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer}.ct-base-modal-header-close:hover{background:rgba(0,0,0,.07)}.ct-base-modal-header-close-icon{cursor:pointer;width:16px;height:16px;border:none;outline:none;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%}.ct-base-modal-body{padding:0 24px}.ct-base-modal-content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:560px;border-radius:10px;overflow:hidden;background-color:#fff;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14)}.ct-base-modal-footer{display:flex;justify-content:flex-end;height:64px;padding:16px 24px;border-radius:0 0 4px 4px}';
styleInject(css_248z$3);

var css_248z$4 = '.ct-checkbox{display:inline-block;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-checkbox input{display:none}.ct-checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;vertical-align:top;margin-right:6px}.ct-checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-checkbox input:checked+.checkbox-bg:after{content:" ";display:table;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
styleInject(css_248z$4);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var noop$1 = function() {};
var CheckBox = /*#__PURE__*/ function(Component) {
    _inherits(CheckBox, Component);
    var _super = _createSuper(CheckBox);
    function CheckBox() {
        _classCallCheck$3(this, CheckBox);
        return _super.apply(this, arguments);
    }
    var _proto = CheckBox.prototype;
    _proto.render = function render() {
        // 设置 onChange 的默认值，防止出现警告
        var _this_props = this.props, checked = _this_props.checked, onClick = _this_props.onClick, _this_props_onChange = _this_props.onChange, onChange = _this_props_onChange === void 0 ? noop$1 : _this_props_onChange, children = _this_props.children;
        return /*#__PURE__*/ React.createElement("div", {
            className: classNamePrefix("checkbox"),
            onClick: onClick
        }, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            checked: checked,
            onChange: onChange
        }), /*#__PURE__*/ React.createElement("span", {
            className: "checkbox-bg"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "checkbox-label"
        }, children));
    };
    return CheckBox;
}(Component);

var css_248z$5 = '.ct-icon-item{position:relative;width:34px;height:34px;cursor:pointer;background-repeat:no-repeat;background-position:50%}.ct-icon-item svg{margin:4px 0 0 4px}.ct-icon-item.close{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526118302462%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 p-id%3D%223872%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%2216%22 height%3D%2216%22%3E%3Cdefs%3E%3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath d%3D%22M512 444.032L209.984 142.08A48 48 0 1 0 142.08 209.92L444.032 512 142.08 814.016A48 48 0 1 0 209.92 881.92L512 579.968l302.016 301.952a48 48 0 1 0 67.904-67.904L579.968 512l301.952-302.016A48 48 0 1 0 814.08 142.08L512 444.032z%22 fill%3D%22%23bbbbbb%22 p-id%3D%223873%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E")}.ct-icon-item.error{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E9%94%99%E8%AF%AF%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-296.000000%2C -544.000000)%22 fill%3D%22%23F05E50%22%3E            %3Cpath fill%3D%22%23F05E50%22 d%3D%22M304%2C544 C308.41824%2C544 312%2C547.58176 312%2C552 C312%2C556.41824 308.41824%2C560 304%2C560 C299.58176%2C560 296%2C556.41824 296%2C552 C296%2C547.58176 299.58176%2C544 304%2C544 Z M299.2%2C552 C299.2%2C552.667362 299.735663%2C553.2 300.396436%2C553.2 L307.603564%2C553.2 C308.256356%2C553.2 308.8%2C552.662742 308.8%2C552 C308.8%2C551.332638 308.264337%2C550.8 307.603564%2C550.8 L300.396436%2C550.8 C299.743644%2C550.8 299.2%2C551.337258 299.2%2C552 Z%22 id%3D%22tost-%E9%94%99%E8%AF%AF%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.success{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2216px%22 height%3D%2216px%22 viewBox%3D%220 0 16 16%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3Etost-%E6%88%90%E5%8A%9F%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-222.000000%2C -544.000000)%22 fill%3D%22%2370B123%22%3E            %3Cpath fill%3D%22%2370B123%22 d%3D%22M228.93934%2C552.865274 L226.802094%2C550.728029 C226.3405%2C550.266435 225.576187%2C550.26192 225.107558%2C550.730549 C224.635662%2C551.202445 224.637801%2C551.957848 225.105038%2C552.425085 L228.079926%2C555.399974 C228.314894%2C555.634941 228.628301%2C555.751472 228.941218%2C555.747447 C229.252578%2C555.751485 229.564571%2C555.634156 229.802094%2C555.396633 L234.898303%2C550.300424 C235.359897%2C549.83883 235.364412%2C549.074517 234.895783%2C548.605887 C234.423887%2C548.133991 233.668484%2C548.13613 233.201247%2C548.603367 L228.93934%2C552.865274 Z M238%2C552 C238%2C553.451396 237.642365%2C554.789924 236.927083%2C556.015625 C236.211802%2C557.241326 235.241326%2C558.211802 234.015625%2C558.927083 C232.789924%2C559.642365 231.451396%2C560 230%2C560 C228.548604%2C560 227.210076%2C559.642365 225.984375%2C558.927083 C224.758674%2C558.211802 223.788198%2C557.241326 223.072917%2C556.015625 C222.357635%2C554.789924 222%2C553.451396 222%2C552 C222%2C550.548604 222.357635%2C549.210076 223.072917%2C547.984375 C223.788198%2C546.758674 224.758674%2C545.788198 225.984375%2C545.072917 C227.210076%2C544.357635 228.548604%2C544 230%2C544 C231.451396%2C544 232.789924%2C544.357635 234.015625%2C545.072917 C235.241326%2C545.788198 236.211802%2C546.758674 236.927083%2C547.984375 C237.642365%2C549.210076 238%2C550.548604 238%2C552 Z%22 id%3D%22tost-%E6%88%90%E5%8A%9F%22%3E%3C%2Fpath%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.edit{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E7%BC%96%E8%BE%91%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-164.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E7%BC%96%E8%BE%91%22 transform%3D%22translate(164.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M13%2C7 C13.2761424%2C7 13.5%2C7.22385763 13.5%2C7.5 C13.5%2C7.77614237 13.2761424%2C8 13%2C8 L8%2C8 L8%2C8 C7.44771525%2C8 7%2C8.44771525 7%2C9 L7%2C9 L7%2C18 C7%2C18.5522847 7.44771525%2C19 8%2C19 L17%2C19 C17.5522847%2C19 18%2C18.5522847 18%2C18 L18%2C18 L18%2C13 C18%2C12.7238576 18.2238576%2C12.5 18.5%2C12.5 C18.7761424%2C12.5 19%2C12.7238576 19%2C13 L19%2C11 L19%2C18 L19%2C18 C19%2C19.1045695 18.1045695%2C20 17%2C20 L8%2C20 L8%2C20 C6.8954305%2C20 6%2C19.1045695 6%2C18 L6%2C9 L6%2C9 C6%2C7.8954305 6.8954305%2C7 8%2C7 L8%2C7 L15%2C7 L13%2C7 Z M19.8535534%2C6.14644661 C20.0488155%2C6.34170876 20.0488155%2C6.65829124 19.8535534%2C6.85355339 L13.4895924%2C13.2175144 C13.2943302%2C13.4127766 12.9777477%2C13.4127766 12.7824856%2C13.2175144 C12.5872234%2C13.0222523 12.5872234%2C12.7056698 12.7824856%2C12.5104076 L19.1464466%2C6.14644661 C19.3417088%2C5.95118446 19.6582912%2C5.95118446 19.8535534%2C6.14644661 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.link{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E  %3Cg stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E    %3Cg transform%3D%22translate(-908.000000%2C -565.000000)%22%3E      %3Cg transform%3D%22translate(8.500000%2C 565.000000)%22%3E        %3Cg transform%3D%22translate(0.500000%2C 0.000000)%22 fill%3D%22%23666666%22%3E          %3Cg transform%3D%22translate(899.000000%2C 0.000000)%22%3E            %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L13.4302151%2C11.1475865 L12.7191158%2C11.8586857 L13.4302151%2C12.5697849 C14.2156736%2C13.3552435 14.2156736%2C14.6287234 13.4302151%2C15.4141819 L13.2808842%2C15.5635128 L12.9253346%2C15.2079632 L13.9919834%2C16.274612 L16.1252811%2C14.1413143 L15.4141819%2C13.4302151 L17.4052599%2C11.439137 C18.1907184%2C10.6536785 18.1907184%2C9.38019862 17.4052599%2C8.59474009 C16.6198014%2C7.80928156 15.3463215%2C7.80928156 14.560863%2C8.59474009 L12.7191158%2C10.4364872 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.visitLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 47.1 (45422) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8E%BB%E6%9F%A5%E7%9C%8B%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-587.000000%2C -162.000000)%22%3E            %3Cg id%3D%22Group-8%22 transform%3D%22translate(62.000000%2C 128.000000)%22%3E                %3Cg id%3D%22Group%22 transform%3D%22translate(0.000000%2C 34.000000)%22%3E%3C%2Fg%3E                %3Cg id%3D%22Group-2%22 transform%3D%22translate(0.000000%2C 34.000000)%22 fill%3D%22%23666666%22%3E                    %3Cg id%3D%22%E5%8E%BB%E6%9F%A5%E7%9C%8B%22 transform%3D%22translate(525.000000%2C 0.000000)%22%3E                        %3Cpath d%3D%22M6.67363116%2C16 L7.80156483%2C16 C8.83909243%2C17.7939653 10.7785899%2C19.0009766 13%2C19.0009766 C16.3142478%2C19.0009766 19.0009766%2C16.3142478 19.0009766%2C13 C19.0009766%2C9.68575216 16.3142478%2C6.99902344 13%2C6.99902344 C10.7785899%2C6.99902344 8.83909243%2C8.20603473 7.80156483%2C10 L6.67363116%2C10 C7.7970951%2C7.63505267 10.207604%2C6 13%2C6 C16.8659932%2C6 20%2C9.13400675 20%2C13 C20%2C16.8659932 16.8659932%2C20 13%2C20 C10.207604%2C20 7.7970951%2C18.3649473 6.67363116%2C16 Z M14.1464466%2C14.767767 L15.4142136%2C13.5 L6.62132034%2C13.5 C6.34517797%2C13.5 6.12132034%2C13.2761424 6.12132034%2C13 C6.12132034%2C12.7238576 6.34517797%2C12.5 6.62132034%2C12.5 L15.4142136%2C12.5 L14.1464466%2C11.232233 C13.9511845%2C11.0369709 13.9511845%2C10.7203884 14.1464466%2C10.5251263 C14.3417088%2C10.3298641 14.6582912%2C10.3298641 14.8535534%2C10.5251263 L16.9535151%2C12.6262866 C16.9607818%2C12.6327579 16.967905%2C12.6394779 16.9748737%2C12.6464466 C17.1701359%2C12.8417088 17.1701359%2C13.1582912 16.9748737%2C13.3535534 L14.8535534%2C15.4748737 C14.6582912%2C15.6701359 14.3417088%2C15.6701359 14.1464466%2C15.4748737 C13.9511845%2C15.2796116 13.9511845%2C14.9630291 14.1464466%2C14.767767 Z%22%3E%3C%2Fpath%3E                    %3C%2Fg%3E                %3C%2Fg%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.cancelLink{background-image:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22%3F%3E%3Csvg width%3D%2226px%22 height%3D%2226px%22 viewBox%3D%220 0 26 26%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E    %3C!-- Generator%3A Sketch 45.1 (43504) - http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch --%3E    %3Ctitle%3E%E5%8F%96%E6%B6%88%E9%93%BE%E6%8E%A5%3C%2Ftitle%3E    %3Cdesc%3ECreated with Sketch.%3C%2Fdesc%3E    %3Cdefs%3E%3C%2Fdefs%3E    %3Cg id%3D%22Page-1%22 stroke%3D%22none%22 stroke-width%3D%221%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Artboard%22 transform%3D%22translate(-96.000000%2C -162.000000)%22 fill%3D%22%23666666%22%3E            %3Cg id%3D%22%E6%8F%92%E5%85%A5%E9%93%BE%E6%8E%A5%22 transform%3D%22translate(96.000000%2C 162.000000)%22%3E                %3Cpath d%3D%22M7.88364085%2C13.8497637 L12.0080166%2C9.72538799 L14.1413143%2C11.8586857 C15.3195021%2C13.0368735 15.3195021%2C14.9470933 14.1413143%2C16.1252811 L12.1502363%2C18.1163592 C10.9720485%2C19.2945469 9.06182865%2C19.2945469 7.88364085%2C18.1163592 C6.70545305%2C16.9381714 6.70545305%2C15.0279515 7.88364085%2C13.8497637 Z M12.7191158%2C10.4364872 L12.5697849%2C10.5858181 C11.7843264%2C11.3712766 11.7843264%2C12.6447565 12.5697849%2C13.4302151 L13.2808842%2C14.1413143 L12.5697849%2C14.8524135 L12.9253346%2C15.2079632 L11.8586857%2C14.1413143 C10.6804979%2C12.9631265 10.6804979%2C11.0529067 11.8586857%2C9.87471885 L12.0080166%2C9.72538799 L12.7191158%2C10.4364872 Z M13.2808842%2C15.5635128 L11.439137%2C17.4052599 C10.6536785%2C18.1907184 9.38019862%2C18.1907184 8.59474009%2C17.4052599 C7.80928156%2C16.6198014 7.80928156%2C15.3463215 8.59474009%2C14.560863 L10.5858181%2C12.5697849 L9.87471885%2C11.8586857 L13.8497637%2C7.88364085 C15.0279515%2C6.70545305 16.9381714%2C6.70545305 18.1163592%2C7.88364085 C19.2945469%2C9.06182865 19.2945469%2C10.9720485 18.1163592%2C12.1502363 L13.9919834%2C16.274612 L13.2808842%2C15.5635128 L13.2808842%2C15.5635128 Z M12.7191158%2C10.4364872 L14.560863%2C8.59474009 C15.3463215%2C7.80928156 16.6198014%2C7.80928156 17.4052599%2C8.59474009 C18.1907184%2C9.38019862 18.1907184%2C10.6536785 17.4052599%2C11.439137 L15.4141819%2C13.4302151 L16.1252811%2C14.1413143 L13.9919834%2C16.274612 L12.9253346%2C15.2079632 L13.2808842%2C15.5635128 L13.4302151%2C15.4141819 C14.2156736%2C14.6287234 14.2156736%2C13.3552435 13.4302151%2C12.5697849 L12.7191158%2C11.8586857 L13.4302151%2C11.1475865 L12.7191158%2C10.4364872 Z M7.35355339%2C7.35355339 C7.54881554%2C7.15829124 7.86539803%2C7.15829124 8.06066017%2C7.35355339 L9.47487373%2C8.76776695 C9.67013588%2C8.9630291 9.67013588%2C9.27961159 9.47487373%2C9.47487373 C9.27961159%2C9.67013588 8.9630291%2C9.67013588 8.76776695%2C9.47487373 L7.35355339%2C8.06066017 C7.15829124%2C7.86539803 7.15829124%2C7.54881554 7.35355339%2C7.35355339 Z M16.3535534%2C16.3535534 C16.5488155%2C16.1582912 16.865398%2C16.1582912 17.0606602%2C16.3535534 L18.4748737%2C17.767767 C18.6701359%2C17.9630291 18.6701359%2C18.2796116 18.4748737%2C18.4748737 C18.2796116%2C18.6701359 17.9630291%2C18.6701359 17.767767%2C18.4748737 L16.3535534%2C17.0606602 C16.1582912%2C16.865398 16.1582912%2C16.5488155 16.3535534%2C16.3535534 Z M17%2C14.5 C17%2C14.2238576 17.2238576%2C14 17.5%2C14 L19.5%2C14 C19.7761424%2C14 20%2C14.2238576 20%2C14.5 C20%2C14.7761424 19.7761424%2C15 19.5%2C15 L17.5%2C15 C17.2238576%2C15 17%2C14.7761424 17%2C14.5 Z M6%2C11.5 L6%2C11.5 C6%2C11.2238576 6.22385763%2C11 6.5%2C11 L8.5%2C11 C8.77614237%2C11 9%2C11.2238576 9%2C11.5 C9%2C11.7761424 8.77614237%2C12 8.5%2C12 L6.5%2C12 L6.5%2C12 C6.22385763%2C12 6%2C11.7761424 6%2C11.5 L6%2C11.5 Z M11.5%2C6 L11.5%2C6 C11.7761424%2C6 12%2C6.22385763 12%2C6.5 L12%2C8.5 C12%2C8.77614237 11.7761424%2C9 11.5%2C9 C11.2238576%2C9 11%2C8.77614237 11%2C8.5 L11%2C6.5 L11%2C6.5 C11%2C6.22385763 11.2238576%2C6 11.5%2C6 L11.5%2C6 Z M14.5%2C17 C14.7761424%2C17 15%2C17.2238576 15%2C17.5 L15%2C19.5 C15%2C19.7761424 14.7761424%2C20 14.5%2C20 C14.2238576%2C20 14%2C19.7761424 14%2C19.5 L14%2C17.5 C14%2C17.2238576 14.2238576%2C17 14.5%2C17 Z%22 id%3D%22Combined-Shape%22%3E%3C%2Fpath%3E            %3C%2Fg%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomin{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25%22 fill%3D%22%23666%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}.ct-icon-item.zoomout{background-image:url("data:image/svg+xml,%3Csvg width%3D%2226%22 height%3D%2226%22 viewBox%3D%220 0 26 26%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E    %3Cg id%3D%22Page-1%22 fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E        %3Cg id%3D%22Group-4-Copy%22 transform%3D%22translate(6 6)%22%3E            %3Ccircle id%3D%22Oval-3%22 stroke%3D%22%23666%22 cx%3D%226.5%22 cy%3D%226.5%22 r%3D%226%22%3E%3C%2Fcircle%3E            %3Crect id%3D%22Rectangle-25-Copy%22 fill%3D%22%23666%22 transform%3D%22rotate(90 6.5 6.5)%22 x%3D%226%22 y%3D%223%22 width%3D%221%22 height%3D%227%22 rx%3D%22.5%22%3E%3C%2Frect%3E            %3Crect id%3D%22Rectangle-23%22 fill%3D%22%23666%22 transform%3D%22rotate(-45 12.12 12.12)%22 x%3D%2211.62%22 y%3D%229.62%22 width%3D%221%22 height%3D%225%22 rx%3D%22.5%22%3E%3C%2Frect%3E        %3C%2Fg%3E    %3C%2Fg%3E%3C%2Fsvg%3E")}';
styleInject(css_248z$5);

var css_248z$6 = '.ct-base-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-base-toolbar .split{width:1px;height:14px;margin-top:0;background:#d9d9d9}.ct-base-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-base-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}';
styleInject(css_248z$6);

var css_248z$7 = '.ct-editor-container .ct-node-view-dom.ProseMirror-selectednode .ct-pc-resizer{display:block;outline:1px dashed #9b9b9b}.ct-editor-container .ct-pc-resizer{display:none;position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-editor-container .ct-pc-resizer-point{position:absolute;height:20px;width:20px;pointer-events:all}.ct-editor-container .ct-pc-resizer-point:after{content:"";position:absolute;left:4px;top:4px;height:12px;width:12px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-editor-container .ct-pc-resizer-point.lt{cursor:pointer;left:-10px;top:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-point.rt{cursor:pointer;right:-10px;top:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.lb{cursor:pointer;left:-10px;bottom:-10px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer-point.rb{cursor:pointer;right:-10px;bottom:-10px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point{height:30px;width:30px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point:after{left:9px;top:9px}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lt{cursor:pointer;left:-15px;top:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rt{cursor:pointer;right:-15px;top:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.lb{cursor:pointer;left:-15px;bottom:-15px;cursor:nesw-resize}.ct-editor-container .ct-pc-resizer .large-hot-area.ct-pc-resizer-point.rb{cursor:pointer;right:-15px;bottom:-15px;cursor:nwse-resize}.ct-editor-container .ct-pc-resizer-info{position:absolute;height:20px;line-height:20px;padding:0 4px;text-align:center;background:rgba(0,0,0,.72);border-radius:4px;font-size:12px;color:#fff}.ct-editor-container .ct-pc-resizer-info.lt{left:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.lt.out{left:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.lb{left:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.lb.out{left:-60px;bottom:0}.ct-editor-container .ct-pc-resizer-info.rt{right:9px;top:9px}.ct-editor-container .ct-pc-resizer-info.rt.out{right:-60px;top:0}.ct-editor-container .ct-pc-resizer-info.rb{right:9px;bottom:9px}.ct-editor-container .ct-pc-resizer-info.rb.out{right:-60px;bottom:0}.ct-editor-container .ct-pc-resizer .auto-hide{display:none}.ct-editor-container .ct-pc-resizer-point:hover~.auto-hide{display:block}';
styleInject(css_248z$7);

var css_248z$8 = '.ct-note-toolbar{display:flex;align-items:center;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease;background:#fff;font-size:12px;box-shadow:0 4px 16px 0 rgb(106 93 73/20%),0 8px 20px 0 rgb(106 93 73/10%);border-radius:1px;pointer-events:all}.ct-note-toolbar .split{width:1px;height:14px;margin-top:0;background:#d8d8d8}.ct-toolbar-tooltip{position:absolute;left:50%;transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:"";z-index:1}.ct-note-toolbar .checkbox{display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:relative;height:16px;margin-right:6px;vertical-align:-13%;cursor:pointer;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ct-note-toolbar .checkbox input{display:none}.ct-note-toolbar .checkbox .checkbox-bg{position:relative;display:inline-block;box-sizing:border-box;width:16px;height:16px;border:1px solid #ddd;border-radius:2px;margin-right:6px}.ct-note-toolbar .checkbox input:checked+.checkbox-bg{background-color:#1c6cdc;border-color:#1c6cdc}.ct-note-toolbar .checkbox input:checked+.checkbox-bg:after{content:" ";display:inline-block;position:absolute;left:4px;top:2px;width:5px;height:8px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg)}';
styleInject(css_248z$8);

/* eslint-disable jsx-a11y/label-has-associated-control */ function _assertThisInitialized$1(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$4(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _possibleConstructorReturn$1(self, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$1(self);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var _typeof$1 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$1(this, result);
    };
}
var Toolbar = /*#__PURE__*/ function(Component) {
    _inherits$1(Toolbar, Component);
    var _super = _createSuper$1(Toolbar);
    function Toolbar(props) {
        _classCallCheck$4(this, Toolbar);
        var _this;
        _this = _super.call(this, props);
        _this.container = null;
        _this.handleCheckboxChange = function(e) {
            e.stopPropagation();
            e.preventDefault();
            var hiddenTitle = _this.state.hiddenTitle;
            var toggleTitle = _this.props.toggleTitle;
            var newhiddenTitle = !hiddenTitle;
            _this.setState({
                hiddenTitle: newhiddenTitle
            });
            toggleTitle(newhiddenTitle);
        };
        _this.state = {
            hiddenTitle: props.hiddenTitle
        };
        return _this;
    }
    var _proto = Toolbar.prototype;
    _proto.render = function render() {
        var _this = this;
        var hiddenTitle = this.state.hiddenTitle;
        return /*#__PURE__*/ React.createElement("div", {
            ref: function(r) {
                _this.container = r;
            },
            className: "".concat(classNamePrefix("base-toolbar"), " ").concat(classNamePrefix("note-toolbar"))
        }, /*#__PURE__*/ React.createElement(CheckBox, {
            checked: !hiddenTitle,
            onClick: this.handleCheckboxChange
        }, i18nClient.t("pk_title", "标题")));
    };
    return Toolbar;
}(Component);

function _assertThisInitialized$2(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$5(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn$2(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$2(self);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
var _typeof$2 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$2(this, result);
    };
}
var NotePopover = /*#__PURE__*/ function(PluginView) {
    _inherits$2(NotePopover, PluginView);
    var _super = _createSuper$2(NotePopover);
    function NotePopover() {
        _classCallCheck$5(this, NotePopover);
        var _this;
        _this = _super.apply(this, arguments);
        /**
   * 获取当前选区位置
   */ _this.getPos = function() {
            var state = _this.view.state;
            return state.selection.from;
        };
        _this.getDom = function() {
            return _this.view.nodeDOM(_this.getPos());
        };
        _this.updateAttrs = function(data) {
            var _this_view = _this.view, state = _this_view.state, dispatch = _this_view.dispatch;
            var foundNode = findParentNode(function(node) {
                return node.type === state.schema.nodes.note;
            })(state.selection);
            if (!foundNode) {
                return;
            }
            var pos = foundNode.pos, node = foundNode.node;
            var tr = state.tr, schema = state.schema;
            var nodeType = schema.nodes.note;
            var attrs = _objectSpread$1({}, node.attrs, data);
            dispatch(tr.setNodeMarkup(pos, nodeType, attrs));
        };
        return _this;
    }
    var _proto = NotePopover.prototype;
    _proto.getNode = function getNode(view) {
        var state = view.state;
        var foundNode = findParentNode(function(node) {
            return node.type === state.schema.nodes.note;
        })(state.selection);
        if (!foundNode) {
            return null;
        }
        var pos = foundNode.pos;
        return view.nodeDOM(pos);
    };
    _proto.getContent = function getContent() {
        var _this = this;
        var state = this.view.state;
        var foundNode = findParentNode(function(node) {
            return node.type === state.schema.nodes.note;
        })(state.selection);
        if (!foundNode) {
            return null;
        }
        var hiddenTitle = foundNode.node.attrs.hiddenTitle;
        return /*#__PURE__*/ React.createElement(Toolbar, {
            hiddenTitle: hiddenTitle,
            toggleTitle: function(value) {
                _this.updateAttrs({
                    hiddenTitle: value
                });
            }
        });
    };
    return NotePopover;
}(PluginView);

function _assertThisInitialized$3(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck$6(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf$3(o) {
    _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$3(o);
}
function _inherits$3(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$3(subClass, superClass);
}
function _possibleConstructorReturn$3(self, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized$3(self);
}
function _setPrototypeOf$3(o, p) {
    _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$3(o, p);
}
var _typeof$3 = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$3(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$3(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn$3(this, result);
    };
}
var pluginKey = new PluginKey("note");
var NoteExtension = /*#__PURE__*/ function(NodeExtension) {
    _inherits$3(NoteExtension, NodeExtension);
    var _super = _createSuper$3(NoteExtension);
    function NoteExtension() {
        _classCallCheck$6(this, NoteExtension);
        return _super.apply(this, arguments);
    }
    var _proto = NoteExtension.prototype;
    _proto.plugin = function plugin() {
        return new Plugin({
            key: pluginKey,
            props: {
                handleKeyDown: function(view, event) {
                    if (event.keyCode !== Keycodes.BackSpace) {
                        return false;
                    }
                    var _view_state = view.state, sel = _view_state.selection;
                    if (sel.empty) {
                        var $anchor = sel.$anchor;
                        var parent = $anchor.node(-1);
                        /**
             * 如果在空的样式宏内则不进行任何处理
             */ var isBeganInNoteContent = parent && parent.type.name === "note_content" && parent.firstChild === $anchor.parent && $anchor.parentOffset === 0;
                        if (isBeganInNoteContent) {
                            return true;
                        }
                    }
                    return false;
                },
                decorations: function(state) {
                    var selection = state.selection, schema = state.schema, doc = state.doc;
                    var note = schema.nodes.note;
                    var foundNode = findParentNode(function(node) {
                        return node.type === note;
                    })(selection);
                    if (foundNode) {
                        var deco = Decoration.node(foundNode.pos, foundNode.node.nodeSize + foundNode.pos, {
                            nodeName: "div",
                            class: classNamePrefix("note-selected")
                        });
                        return DecorationSet.create(doc, [
                            deco
                        ]);
                    }
                }
            },
            view: function(view) {
                return new NotePopover(view, {
                    className: classNamePrefix("note-popover"),
                    isSticky: false
                });
            }
        });
    };
    _proto.commands = function commands(param) {
        var editorEventEmitter = param.editorEventEmitter;
        return {
            insertNote: execAfterCommands(insertNote, function() {
                return editorEventEmitter.emit(AFTER_INSERT, {
                    braceWidth: 300
                });
            })
        };
    };
    _proto.transformPastedHTML = function transformPastedHTML(html) {
        if (html.includes("ct-note")) {
            // 如果粘贴样式宏时，结构中没有 note_title 则手动添加上，todo: 感觉这里应该在复制逻辑里实现
            var createDom = document.createElement("div");
            createDom.innerHTML = html;
            var noteDoms = createDom.querySelectorAll(".ct-note");
            noteDoms.forEach(function(noteDom) {
                if (!noteDom.innerHTML.includes("ct-note-title")) {
                    var noteTitleDom = document.createElement("div");
                    noteTitleDom.className = "ct-note-title";
                    noteTitleDom.innerHTML = '<span class="ct-note-title-text"></span>';
                    noteDom.insertBefore(noteTitleDom, noteDom.firstChild);
                }
            });
            html = createDom.innerHTML;
        }
        var noteTestReg = /class="ct-note-[^>]*?data-pm-slice="/;
        var noteExecReg = /class="ct-note-[^>]*>([\s\S]*?)<\/div>/;
        if (html.includes('data-pm-slice="')) {
            if (!html.includes('data-pm-slice="none"')) {
                if (noteTestReg.test(html)) {
                    html = noteExecReg.exec(html)[1];
                }
            }
        }
        return html;
    };
    _createClass(NoteExtension, [
        {
            key: "name",
            get: function get() {
                return "note";
            }
        }
    ]);
    return NoteExtension;
}(NodeExtension);

export { NoteExtension, pluginKey };
//# sourceMappingURL=index.js.map
